import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import logo from "@/assets/logo-clean-transparent.webp";

export const StoreFooter = () => {
  return (
    <footer className="border-t border-border py-12 bg-card">
      <div className="container space-y-8">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <img src={logo} alt="Param Kesar®" className="h-16 w-auto" width={200} height={64} loading="lazy" decoding="async" />
          <nav aria-label="Footer" className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-muted-foreground">
            <Link to="/contact" className="hover:text-foreground">Contact</Link>
            <Link to="/thekesarkitchen" className="hover:text-foreground">The Kesar Kitchen™</Link>
            <Link to="/why-saffron" className="hover:text-foreground">Why Saffron?</Link>
            <Link to="/saffron-guide" className="hover:text-foreground">Saffron Guide</Link>
            <Link to="/kashmiri-chai" className="hover:text-foreground">Kashmiri Chai Guide</Link>
            <Link to="/kahwa" className="hover:text-foreground">Kahwa Guide</Link>
            <Link to="/faq" className="hover:text-foreground">FAQ</Link>
            <Link to="/wholesale" className="hover:text-foreground">Wholesale</Link>
            <Link to="/pantry" className="hover:text-foreground">Kashmiri Pantry</Link>
            <Link to="/pampore" className="hover:text-foreground">Our Source</Link>
            <Link to="/press" className="hover:text-foreground">Press</Link>
            <Link to="/shipping" className="hover:text-foreground">Shipping</Link>
            <Link to="/refunds" className="hover:text-foreground">Refunds</Link>
            <Link to="/privacy" className="hover:text-foreground">Privacy</Link>
            <Link to="/terms" className="hover:text-foreground">Terms</Link>
          </nav>
          <div className="flex items-center gap-3">
            <a
              href="https://www.facebook.com/people/Param-Kesar-US/61553244375191/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Param Kesar® on Facebook"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <Facebook className="h-5 w-5" />
            </a>
            <a
              href="https://www.instagram.com/param.kesar.us/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Param Kesar® on Instagram"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <Instagram className="h-5 w-5" />
            </a>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-start md:items-start justify-between gap-4 border-t border-border pt-6 text-xs text-muted-foreground">
          <div className="space-y-1">
            <p>© {new Date().getFullYear()} Gourmet Delights LLC dba Param Kesar®. All rights reserved.</p>
            <address className="not-italic">
              7901 4th St. N. Ste 300, St. Petersburg, FL 33702
            </address>
            <p>
              <a href="tel:+18339866699" className="hover:text-foreground">(833) 986-6699</a>
              {" · "}
              <a href="mailto:support@paramkesar.co" className="hover:text-foreground">support@paramkesar.co</a>
              {" · Mon–Fri, 9am–4pm ET"}
            </p>
          </div>
          <p className="md:max-w-sm md:text-right">
            These statements have not been evaluated by the FDA. Products are not
            intended to diagnose, treat, cure, or prevent any disease.
          </p>
        </div>
      </div>
    </footer>
  );
};
